import { useEffect } from 'react'

import { ChartContainer } from './ChartContainer'
import { ChartErrorBoundary } from './ChartErrorBoundary'

import { useChartStore } from '@/stores/chartStore'
import { useLayoutStore } from '@/stores/layoutStore'
import { GRID_LAYOUTS } from '@/types/chart'

export function ChartGrid() {
  const { gridSize } = useLayoutStore()
  const { panels, initPanels } = useChartStore()
  const { cols, rows } = GRID_LAYOUTS[gridSize]

  // Keep panel count in sync with gridSize on every layout change and on mount.
  // Without this, localStorage could have a different panel count than gridSize.
  useEffect(() => {
    initPanels(gridSize)
  }, [gridSize, initPanels])

  const panelIds = Object.keys(panels)

  return (
    <div
      className="grid h-full w-full bg-tv-border"
      style={{
        gridTemplateColumns: `repeat(${cols}, 1fr)`,
        gridTemplateRows: `repeat(${rows}, 1fr)`,
        gap: '1px',
      }}
    >
      {panelIds.map((id) => (
        <div key={id} className="overflow-hidden bg-tv-bg-primary">
          <ChartErrorBoundary panelId={id}>
            <ChartContainer panelId={id} />
          </ChartErrorBoundary>
        </div>
      ))}
    </div>
  )
}
